import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <motion.div initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    duration: 0.5,
    type: 'spring'
  }} className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group" data-id="element-131">
      <div className="bg-white text-wellness-dark text-sm font-medium py-2 px-4 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none transform translate-x-2 group-hover:translate-x-0" data-id="element-132">
        ¿Tienes dudas?
      </div>

      <a href="https://wa.me/" target="_blank" rel="noopener noreferrer" className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20ba56] transition-colors" aria-label="Contactar por WhatsApp" data-id="element-133">
        <MessageCircle className="w-7 h-7" data-id="element-134" />

        {/* Pulse effect */}
        <span className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-75" data-id="element-135" />
      </a>
    </motion.div>;
}